[
  {
    "title": "Biological activity",
    "subcategories": [
      "Angiogenic",
      "Anti-HIV",
      "Anti-MDR (multidrug-resistance)",
      "Antiallergic",
      "Antibiotic",
      "Anticancer",
      "Antifeedant",
      "Antifertility",
      "Antifouling",
      "Antifungal",
      "Antihelminthic",
      "Antihistamine",
      "Antihypertensive",
      "Antiinflammatory",
      "Antileukemia",
      "Antimalarial",
      "Antimitotic/cytokinesis inhibition",
      "Antimutagenic",
      "Antineoplastic",
      "Antioxidative",
      "Antispasmodic",
      "Antitumour",
      "Antiviral",
      "Bioassay methods",
      "Brine shrimp assay",
      "Carcinogen",
      "Clinically induced tumors",
      "Cytotoxicity",
      "Ecdysone-like moulting",
      "Enzyme activation",
      "Enzyme inhibition",
      "Gene expression suppression",
      "Herbicidal",
      "Immunomodulatory (unspecified)",
      "Immunostimulatory",
      "Immunosuppression",
      "Inflammatory",
      "Insecticidal",
      "Larva metamorphosis inducer",
      "Laxative",
      "Mechanism of action",
      "Neurodepressive",
      "Neuroexcitory",
      "Other assays",
      "P388/L1210/KB/HC8",
      "Protein kinase inhibitory",
      "Radioimmuno assay",
      "Sea urchin egg inhib",
      "Structure-activity studies",
      "Tumor promoter",
      "Vasoconstrictor",
      "Vasodilator"
    ],
    "isOpen": false
  },
  {
    "title": "Chemistry",
    "subcategories": [
      "Absolute configuration",
      "Analogue",
      "Biosynthesis",
      "Chemotaxonomy",
      "Conformational study",
      "Coordination",
      "Kinetics",
      "Organometallic",
      "Protecting groups",
      "Radio/isotope labelling",
      "Relative configuration",
      "Stereochemistry"
    ],
    "isOpen": false
  },
  {
    "title": "Culturing",
    "subcategories": [
      "Algal culturing",
      "Aquaculture",
      "Bacterial culturing",
      "Culture growth dynamics",
      "Fungal culturing",
      "Genome transfer",
      "Tissue culturing"
    ],
    "isOpen": false
  },
  {
    "title": "Ecological",
    "subcategories": [
      "Allomones",
      "Biogeographic variations",
      "Chemical associations",
      "Chemical defense",
      "Ecology",
      "Intraspecific variation",
      "Kairomones",
      "Metabolite source",
      "Pheromones",
      "Seasonal variations",
      "Symbiosis",
      "Tissue distribution"
    ],
    "isOpen": false
  },
  {
    "title": "Functional groups",
    "subcategories": [
      "Acetylenic ethers",
      "Acids",
      "Alcohols",
      "Aldehyde",
      "Alkanes",
      "Alkenes",
      "Alkynes",
      "Amides",
      "Amines",
      "Amino acid",
      "Aromatic",
      "Bromo",
      "Carbonyl",
      "Carboxylic acid",
      "Chloro",
      "Cyclic",
      "Cycloprop",
      "Epoxides",
      "Ester",
      "Ether",
      "Fluoro",
      "Furans",
      "Glycosides",
      "Guanidine",
      "Heavy metal",
      "Heterocyclic",
      "Imidazole",
      "Indoles",
      "Iodo",
      "Isocyanide",
      "Isonitriles",
      "Isothiocyanate",
      "Ketals",
      "Lactones",
      "Nitriles",
      "Peroxide",
      "Pyrans",
      "Pyrone",
      "Pyrrole",
      "Quinone",
      "Sulfate",
      "Sulfur",
      "Thiazole",
      "Thiocyanate"
    ],
    "isOpen": false
  },
  {
    "title": "Geographic regions",
    "subcategories": [
      "Antarctic",
      "Arctic",
      "Australia",
      "Baltic Sea",
      "Black Sea",
      "Caribbean",
      "Caspian Sea",
      "China Sea",
      "Coral Sea",
      "Dead Sea",
      "Eastern Atlantic",
      "Eastern Pacific",
      "Hawaii",
      "Indian Ocean",
      "Japan",
      "Mediterranean",
      "New Zealand",
      "North Sea",
      "Red Sea",
      "Russia",
      "Tropical",
      "Western Atlantic",
      "Western Pacific"
    ],
    "isOpen": false
  },
  {
    "title": "Organism types",
    "subcategories": [
      "Annelids",
      "Arthropods",
      "Ascidians",
      "Bacteria",
      "Brachiopods",
      "Brown algae",
      "Bryozoans",
      "Cnidarians",
      "Cyanobacteria",
      "Diatoms",
      "Dinoflagellates",
      "Echinoderms",
      "Fish",
      "Fungi",
      "Green algae",
      "Mangroves",
      "Microalgae",
      "Molluscs",
      "Nematodes",
      "Platyhelminthes",
      "Red algae",
      "Sponges"
    ],
    "isOpen": false
  },
  {
    "title": "Reviews",
    "subcategories": [
      "Biosynthesis review",
      "Ecology review",
      "Marine chemistry",
      "Other reviews"
    ],
    "isOpen": false
  },
  {
    "title": "Sea regions",
    "subcategories": [
      "Deep sea",
      "Estuarine",
      "Intertidal (littoral)",
      "Mangroves",
      "Reef",
      "Shelf",
      "Slope",
      "Sublittoral"
    ],
    "isOpen": false
  },
  {
    "title": "Structural methods",
    "subcategories": [
      "2D NMR",
      "Carbon NMR",
      "Cd/ord/optical rotation",
      "Chemical conversion",
      "Chemical degradation",
      "Gas chromatography/mass spectrometry",
      "Infrared spectroscopy",
      "Liquid chromatography/mass spectrometry",
      "Mass spectrometry",
      "Molecular modelling",
      "Mosher's method",
      "NMR - other nuclei",
      "NOE methods",
      "Protein sequencing",
      "Proton NMR",
      "UV/visible spectroscopy",
      "X-ray crystallography"
    ],
    "isOpen": false
  },
  {
    "title": "Structural type",
    "subcategories": [
      "Alkaloids",
      "Ansamycins",
      "Carotenoids",
      "Cembranoid",
      "Cerebro-/sphingo-/ceramides",
      "Diterpenoid",
      "Fatty acids/lipids",
      "Macrocycle",
      "Macrolide",
      "Monoterpenoid",
      "Nucleosides & tides",
      "Peptides and proteins",
      "Phlorotannins",
      "Phospholipids",
      "Polyether",
      "Polyhalo",
      "Polyketide",
      "Porphyrin",
      "Prostanoid",
      "Purine",
      "Saccharides",
      "Saponin",
      "Sesquiterpenoid",
      "Sesterterpenoid",
      "Spirocyclic",
      "Steroids/sterols",
      "Terpenes (unspecified)",
      "Tetraterpenoid",
      "Triterpenoid",
      "Tryptophan derived",
      "Tyrosine derived"
    ],
    "isOpen": false
  },
  {
    "title": "Synthesis",
    "subcategories": [
      "Asymmetric synthesis",
      "Biomimetic",
      "Enzymatic (cell free)",
      "Microbial methods",
      "Other synthetic methods",
      "Partial synthesis",
      "Photochemistry"
    ],
    "isOpen": false
  },
  {
    "title": "Toxins",
    "subcategories": [
      "Amnesiac (ASP) toxin",
      "Cardiotoxin",
      "Diarrhetic (DSP) toxin",
      "Gastrotoxin",
      "Hepatotoxin",
      "Ichthyotoxin",
      "Neurotoxic (NSP) toxin",
      "Neurotoxin",
      "Paralytic (PSP) toxin",
      "Toxins general"
    ],
    "isOpen": false
  },
  {
    "title": "Non-English language",
    "subcategories": [
      "Chinese",
      "French",
      "German",
      "Italian",
      "Japanese",
      "Korean",
      "Other language",
      "Russian",
      "Spanish"
    ],
    "isOpen": false
  },
  {
    "title": "Non-marine natural products",
    "subcategories": [
      "Freshwater",
      "Lake",
      "Terrestrial"
    ],
    "isOpen": false
  },
  {
    "title": "Other",
    "subcategories": [
      "All other topics",
      "Evolutionary significance",
      "National Cancer Institute",
      "Patent",
      "Physiology",
      "Press reports",
      "Socio-economic impact",
      "Supporting information",
      "Taxonomic"
    ],
    "isOpen": false
  },
  {
    "title": "Pharmacology",
    "subcategories": [
      "Chemotherapy",
      "Pharmacokinetics",
      "Pharmacological techniques"
    ],
    "isOpen": false
  },
  {
    "title": "Extraction methods",
    "subcategories": [
      "Freeze drying",
      "Solid phase extraction",
      "Soxhlet extraction",
      "Super critical fluid",
      "Variations in extraction techn",
      "Wet extraction with solvents"
    ],
    "isOpen": false
  },
  {
    "title": "Separation methods",
    "subcategories": [
      "Chiral GLC and HPLC",
      "Column chromatography",
      "Counter current distribution",
      "DNA binding chromatography",
      "Electrophoresis",
      "Flash chromatography",
      "Gas-liquid chromatography",
      "Gel permeation chromatography",
      "High performance liquid chromatography",
      "Ion exchange",
      "Liquid-liquid chromatography",
      "Thin layer chromatography",
      "Toxin detection methods",
      "Ultrafiltration"
    ],
    "isOpen": false
  }
]